// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import templateConst from 'app/common/lib/templateConst';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Button, Text } from 'gestalt';

const learnMoreUrl = templateConst.settings.HELP_BLOCKING + '?source=block_dialogue';

type Props = {|
  firstName: string,
  onBlockUser: () => void,
  onClearModal: () => void,
|};

export default function BlockWarning(props: Props) {
  const { firstName, onBlockUser, onClearModal } = props;
  const titleText = i18n._('Block this person?', 'header text asking if we should block the user');
  const cancelText = i18n._('Cancel', 'Cancel blocking a user');

  return (
    <Modal
      accessibilityCloseLabel={cancelText}
      accessibilityModalLabel={titleText}
      onDismiss={onClearModal}
      heading={titleText}
      footer={
        <Box
          marginLeft={-1}
          marginRight={-1}
          display="flex"
          alignItems="center"
          justifyContent="end"
        >
          <Box padding={1}>
            <Button size="md" text={cancelText} onClick={onClearModal} />
          </Box>
          <Box padding={1}>
            <Button
              size="md"
              color="red"
              text={i18n._('Block', 'Button to confirm blocking a user')}
              onClick={onBlockUser}
            />
          </Box>
        </Box>
      }
      role="alertdialog"
      size="md"
    >
      <Box padding={4} data-test-id="block-text">
        <Text size="sm">
          {interpolateNamedTemplate(
            i18n._(`If you block {{ name }}, you won’t be able to follow each
  other or interact with each other’s Pins.`),
            {
              name: (
                <Text inline key="name" size="sm" weight="bold">
                  {firstName}
                </Text>
              ),
            },
          )}
        </Text>
      </Box>
      <Box padding={4}>
        <NavigateLink external to={learnMoreUrl}>
          <Text color="darkGray" size="sm" weight="bold">
            {i18n._('Learn more', 'link to help center to learn more about blocking')}
          </Text>
        </NavigateLink>
      </Box>
    </Modal>
  );
}
